import { render, staticRenderFns } from "./set-mixes.vue?vue&type=template&id=4cf37ae6&scoped=true"
import script from "./set-mixes.vue?vue&type=script&lang=js"
export * from "./set-mixes.vue?vue&type=script&lang=js"
import style0 from "./set-mixes.vue?vue&type=style&index=0&id=4cf37ae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf37ae6",
  null
  
)

export default component.exports